<template>
  <div style="border-top: solid 1px #d8d8d8">
    <div
      class="d-flex justify-content-center w-100"
      style="margin-top: 110px"
      v-if="tableLoading">
      <loading />
    </div>

    <div v-else class="d-flex flex-column p-3">
      <!-- dataTable y botones -->
      <div class="d-flex flex-row flex-wrap justify-content-start mb-2">
        <!-- Botones -->
        <div class="w-100">
          <div
            class="d-flex"
            style="position: absolute; z-index: 2"
            :style="[zIndexModal && { 'z-index': '0' }]">

            <paleta-colores-modal />

            <filtros-tracking class="mb-3" />

            <tracking-modal :booking-number="tracking_carrier_booking_number" />

            <tracking-modal-v2 :booking-number="tracking_carrier_booking_number" />

            <sinay-iframe-modal
              :urls="sinay_urls"
              :booking-number="tracking_carrier_booking_number">
            </sinay-iframe-modal>

            <VerBLModal :verBL="dataBL" />

          </div>
          <!-- Data Table -->
          <new-data-table
            customHeaders
            :headers="headers"
            :data="dataAux"
            :acciones="acciones"
            :max="10"
            paginacion
            buscar
            numerador
            idtabla="bookings_tracking_list"
            :seleccionar="obtenerFilaSeleccionada"
            withSearch
          />

        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Componentes
import { mapActions, mapState } from "vuex";
import NewDataTable from "../../../components/common/NewDataTable";
import PaletaColoresModal from "../../modals/lineas/booking/bookings_embarcados/PaletaColoresModal";
import VerBLModal from "../../modals/lineas/booking/VerBLModal";
import Loading from "../../common/loading";
import TrackingModal from "@/components/modals/lineas/booking/bookings_embarcados/TrackingModal.vue";
import FiltrosTracking from "@/components/filtros/tracking/FiltrosTracking.vue";
import SinayIframeModal from "@/components/modals/safecube/SinayIframeModal.vue";
import TrackingModalV2 from "@/components/modals/safecube/TrackingModalV2.vue";

export default {
  props: ["data", "url", "tableLoading"],
  computed: {
    ...mapState(["loading", "loadingTable", "zIndexModal"]),
    ...mapState(["AccionCambiarUsuarioActual", "usuarioActual", "isAdmin"]),
    ...mapState("lineas", [
      "dataDatatableTrackingBookingsFiltered"
    ])
  },
  data() {
    return {
      headers: [
        { title: "ID", width: "10px" },
        { title: "N° Booking", width: "60px" },
        { title: "N° Carrier Booking", width: "60px" },
        { title: "Cliente", width: "35px" },
        { title: "Naviera", width: "35px" },
        { title: "Nave", width: "35px" },
        { title: "Consignatario", width: "70px" },
        { title: "POL", width: "60px" },
        { title: "POL ETA", width: "60px" },
        { title: "POD", width: "60px" },
        { title: "POD ETA", width: "60px" },
        { title: "Acciones", width: "20px" }
      ],
      acciones: [],
      dataAux: this.data,
      dataBL: [],
      //
      tracking_carrier_booking_number: "",
      sinay_url: "",
      sinay_urls: []
    };
  },
  components: {
    TrackingModalV2,
    SinayIframeModal,
    TrackingModal,
    NewDataTable,
    FiltrosTracking,
    PaletaColoresModal,
    VerBLModal,
    Loading
  },
  methods: {
    ...mapActions([
      "AccionCambiar",
      "ActionSetLoadingTable",
      "ActionSetVisibleModalVerTracking",
      "ActionSetVisibleModalSinayTracking",
      "ActionSetVisibleModalTrackingV2",
      "ActionSetVisibleModalBL",
      "ActionSetZindexTablaModal"
    ]),

    ...mapActions("lineas", [
      "actionSetBlSearchCarrierBookingNumber"
    ]),

    async generarBotonesAcciones() {

      this.acciones = [];

      this.dataAux.map((item, index) => {

        if (this.usuarioActual.id_role === 1 || this.usuarioActual.id_role === 2 || this.usuarioActual.id_role === 9999 || this.usuarioActual.id_role === 8) {

          let actions_array = [];

          if (item.data_complementaria.has_tracking === 1) {

            actions_array.push({
              icon: `fas fa-ship ${item.data_complementaria.color_indicator}`,
              title: "Ir a Tracking",
              id: index
            });

          } else if (item.data_complementaria.has_tracking === 2) {

            actions_array.push({
              icon: `fas fa-ship ${item.data_complementaria.color_indicator}`,
              title: "Ir a Tracking (1)",
              id: index
            });

          } else if (item.data_complementaria.has_tracking === 3) {

            actions_array.push({
              icon: `fas fa-ship ${item.data_complementaria.color_indicator}`,
              title: "Ir a Tracking (2)",
              id: index
            });

          } else {

            actions_array.push({
              icon: "fas fa-info text-primary zoom zoom",
              title: "No hay tracking",
              id: index
            });

          }

          if (item.data_complementaria.has_bl === 1) {

            actions_array.push(
              {
                icon: "fa fa-book",
                title: "Ver BL",
                id: index
              }
            );

          }

          this.acciones.push(actions_array);

        } else if (this.usuarioActual.id_role === 3) {

          let actions_array = [];

          if (item.data_complementaria.has_tracking === 1) {

            actions_array.push({
              icon: `fas fa-ship ${item.data_complementaria.color_indicator}`,
              title: "Ir a Tracking",
              id: index
            });

          } else if (item.data_complementaria.has_tracking === 2) {

            actions_array.push({
              icon: `fas fa-ship ${item.data_complementaria.color_indicator}`,
              title: "Ir a Tracking (1)",
              id: index
            });

          } else if (item.data_complementaria.has_tracking === 3) {

            actions_array.push({
              icon: `fas fa-ship ${item.data_complementaria.color_indicator}`,
              title: "Ir a Tracking (2)",
              id: index
            });

          } else {

            actions_array.push({
              icon: "fas fa-info text-primary zoom",
              title: "No hay tracking",
              id: index
            });

          }

          if (item.data_complementaria.has_bl === 1) {

            actions_array.push(
              {
                icon: "fa fa-book",
                title: "Ver BL",
                id: index
              }
            );

          }

          this.acciones.push(actions_array);

        } else if (this.usuarioActual.id_role === 4) {

          let actions_array = [];

          if (item.data_complementaria.has_tracking === 1) {

            actions_array.push({
              icon: `fas fa-ship ${item.data_complementaria.color_indicator}`,
              title: "Ir a Tracking",
              id: index + "-" + item.data_complementaria.id
            });

          } else if (item.data_complementaria.has_tracking === 2) {

            actions_array.push({
              icon: `fas fa-ship ${item.data_complementaria.color_indicator}`,
              title: "Ir a Tracking (1)",
              id: index
            });

          } else if (item.data_complementaria.has_tracking === 3) {

            actions_array.push({
              icon: `fas fa-ship ${item.data_complementaria.color_indicator}`,
              title: "Ir a Tracking (2)",
              id: index
            });

          } else {

            actions_array.push({
              icon: "fas fa-info text-primary zoom zoom",
              title: "No hay tracking",
              id: index
            });

          }

          this.acciones.push(actions_array);

        } else if (this.usuarioActual.id_role === 5) {

          let actions_array = [];

          if (item.data_complementaria.has_tracking === 1) {

            actions_array.push({
              icon: `fas fa-ship ${item.data_complementaria.color_indicator}`,
              title: "Ir a Tracking",
              id: index
            });

          } else if (item.data_complementaria.has_tracking === 2) {

            actions_array.push({
              icon: `fas fa-ship ${item.data_complementaria.color_indicator}`,
              title: "Ir a Tracking (1)",
              id: index
            });

          } else if (item.data_complementaria.has_tracking === 3) {

            actions_array.push({
              icon: `fas fa-ship ${item.data_complementaria.color_indicator}`,
              title: "Ir a Tracking (2)",
              id: index
            });

          } else {

            actions_array.push({
              icon: "fas fa-info text-primary zoom zoom",
              title: "No hay tracking",
              id: index
            });

          }

          this.acciones.push(actions_array);

        }

      });

      this.ActionSetLoadingTable(false);

    },

    async obtenerFilaSeleccionada(fila) {

      if (fila.accion === "Ir a Tracking") {

        this.tracking_carrier_booking_number = this.dataAux[fila.id].data_complementaria.carrier_booking_number;

        this.ActionSetVisibleModalVerTracking(true);

      } else if (fila.accion === "Ir a Tracking (1)") {

        this.sinay_urls = this.normalizeSinayUrls(this.dataAux[fila.id].data_complementaria.iframe_urls);

        //this.sinay_url = (this.sinay_urls[0] && this.sinay_urls[0].url) || this.sinay_urls[0] || "";

        this.tracking_carrier_booking_number = this.dataAux[fila.id].data_complementaria.carrier_booking_number;

        this.ActionSetVisibleModalSinayTracking(true);

      } else if (fila.accion === "Ir a Tracking (2)") {

        this.tracking_carrier_booking_number = this.dataAux[fila.id].data_complementaria.carrier_booking_number;

        this.ActionSetVisibleModalTrackingV2(true);

      } else if (fila.accion === "Ver BL") {

        this.dataBL = this.dataAux[fila.id].data[0];

        await this.actionSetBlSearchCarrierBookingNumber(this.dataAux[fila.id].data_complementaria.carrier_booking_number);

        this.ActionSetVisibleModalBL(true);

        this.ActionSetZindexTablaModal(true);

      } else if (fila.accion === "No hay tracking") {

        return this.$vToastify.info("Tracking no disponible. Para más información, contáctenos.", "¡Atención!");

      }

    },

    normalizeSinayUrls(urls) {

      if (typeof urls === "string") {

        try {

          const parsedUrls = JSON.parse(urls);

          return Array.isArray(parsedUrls) ? parsedUrls.filter(Boolean) : [urls];

        } catch (e) {

          return urls ? [urls] : [];

        }

      }

      if (Array.isArray(urls)) {

        return urls.filter(Boolean);

      }

      return urls ? [urls] : [];

    }

  },
  created() {

    setTimeout(() => {

      this.generarBotonesAcciones();

    }, 400);
  },
  watch: {

    data: function(_new) {

      if (_new) {

        this.dataAux = _new;

        this.generarBotonesAcciones();

      }

    }

  }

};
</script>

<style>
.smoke-row {
  animation: smoke_pulse 2.5s ease-in-out infinite;
  color: #c7c7c7;
  text-shadow: 0 0 4px rgba(199, 199, 199, 0.4);
}

.blue-row {
  animation: blue_pulse 2.5s ease-in-out infinite;
  color: #339cdf;
  text-shadow: 0 0 4px rgba(51, 156, 223, 0.5);
}

.gold-row {
  animation: gold_pulse 2.5s ease-in-out infinite;
  color: #d5b03d;
  text-shadow: 0 0 4px rgba(213, 176, 61, 0.5);
}

.green-row {
  animation: green_pulse 2.5s ease-in-out infinite;
  color: #28a745;
  text-shadow: 0 0 4px rgba(40, 167, 69, 0.5);
}

.default-row {
  animation: purple_pulse 2.5s ease-in-out infinite;
  color: #b051ae;
  text-shadow: 0 0 4px rgb(112, 31, 108);
}

@keyframes blue_pulse {
  0% {
    color: #0f71af;
    opacity: 0.8;
    text-shadow: 0 0 4px rgba(15, 113, 175, 0.3);
  }
  50% {
    color: #339cdf;
    opacity: 1;
    text-shadow: 0 0 10px rgba(0, 102, 255, 0.6);
  }
  100% {
    color: #00398d;
    opacity: 0.8;
    text-shadow: 0 0 4px rgba(0, 57, 141, 0.3);
  }
}

@keyframes gold_pulse {
  0% {
    color: #a88a23;
    opacity: 0.8;
    text-shadow: 0 0 4px rgba(184, 154, 39, 0.3);
  }
  50% {
    color: #d5b03d;
    opacity: 1;
    text-shadow: 0 0 10px rgba(230, 194, 84, 0.6);
  }
  100% {
    color: #9b7b1e;
    opacity: 0.8;
    text-shadow: 0 0 4px rgba(155, 123, 30, 0.3);
  }
}

@keyframes green_pulse {
  0% {
    color: #299825;
    opacity: 0.8;
    text-shadow: 0 0 4px rgba(41, 152, 37, 0.3);
  }
  50% {
    color: #28a745;
    opacity: 1;
    text-shadow: 0 0 10px rgba(1, 161, 1, 0.6);
  }
  100% {
    color: darkgreen;
    opacity: 0.8;
    text-shadow: 0 0 4px rgba(0, 100, 0, 0.3);
  }
}

@keyframes smoke_pulse {
  0% {
    color: #c7c7c7;
    opacity: 0.8;
    text-shadow: 0 0 4px rgba(199, 199, 199, 0.3);
  }
  50% {
    color: #a8a8a8;
    opacity: 1;
    text-shadow: 0 0 8px rgba(168, 168, 168, 0.5);
  }
  100% {
    color: #545454;
    opacity: 0.8;
    text-shadow: 0 0 4px rgba(84, 84, 84, 0.3);
  }
}

@keyframes purple_pulse {
  0% {
    color: #e3aee0;
    opacity: 0.8;
    text-shadow: 0 0 4px rgba(224, 160, 222, 0.4);
  }
  50% {
    color: #b051ae;
    opacity: 1;
    text-shadow: 0 0 12px rgba(176, 81, 174, 0.8);
  }
  100% {
    color: #5e2d5c;
    opacity: 0.8;
    text-shadow: 0 0 4px rgba(94, 45, 92, 0.4);
  }
}

</style>
